import React from 'react'
import PropTypes from 'prop-types'

import cl from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import ContainedSection from 'artkive/components/PageSections/ContainedSection'

import { sectionStyles } from './Keepsakes.style'

// ContainedSection with the keepsake gutters. Wrap it in withStyles to style the section (root) or its titleWrap.
const KeepsakeSection = ({ classes, className, ...rest }) => (
  <ContainedSection
    className={cl(classes.root, className)}
    containerClassName={classes.container}
    titleWrapClassName={classes.titleWrap}
    {...rest}
  />
)

KeepsakeSection.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default withStyles(sectionStyles)(KeepsakeSection)
